<lx-form-field-selector
  [label]="label"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [required]="required"
  [iconValidation]="iconValidation"
  [value]="value"
  [itemList]="dataSource"
  [sortCriteria]="[{ property: 'code' }]"
  [buttonView]="false"
  valueExpr="code"
  (valueChange)="handleDateSelected($event)"
></lx-form-field-selector>
